import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_DURATION,
  COURSE_PAUSE_REQUEST_FILTERS,
  currentFiltersSelector,
  setFilterValue,
} from 'features/courseResume';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import Select from 'components/Select';
import styles from './PauseDurationFilter.module.scss';

function PauseDurationFilter() {
  const dispatch = useDispatch();
  const { pauseDuration } = useSelector(currentFiltersSelector);
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: COURSE_PAUSE_REQUEST_FILTERS.pauseDuration,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Pause Duration"
      labelClassName="h5"
      className={classNames(styles.root, 'm-r-xs')}
    >
      <Select
        styles={_styles}
        options={COURSE_PAUSE_REQUEST_DURATION}
        value={pauseDuration}
        onChange={handleOnChange}
        menuPlacement="auto"
      />
    </Field>
  );
}

export default PauseDurationFilter;
